<script setup>
import { ref, defineEmits, onMounted, defineProps} from 'vue';
import requestApi from '@/utils/requestApi';
import { useGlobalStateStore, useFelixBagAuxStore } from '../../../../store';

const globalStateStore = useGlobalStateStore();
const mentors = ref([])
const felixBagAuxStore = useFelixBagAuxStore();

defineEmits(["close-mentor"])
const props = defineProps(['choosedMentor'])

const mentorsSelected = ref([])
const showModalSendMentors = ref(false)
const loadingRequest = ref(false)
const showModalChoosingMentors = ref(false)
const holdMentor = ref({})

onMounted(() => {
  getMentors()
  felixBagAuxStore.pauseVideo()
  console.log(props.choosedMentor)
})

function getMentors() {
  requestApi({
    url: `/v2/mentors`,
    method: 'get',
    headers: {
        BCS: globalStateStore.uuid,
    }
  }).then(response => {
    mentors.value = response.data.mentors
  })
}

function addMentor(item) {
  console.log(item)
  let index = mentorsSelected.value.findIndex(obj => obj._id === item._id)
  if (index === -1 && mentorsSelected.value.length < 3) {
    mentorsSelected.value.push(item);
  } else if (index === -1 && mentorsSelected.value.length === 3) {
    mentorsSelected.value.splice(0, 1);
    mentorsSelected.value.push(item);
  } else {
    mentorsSelected.value.splice(index, 1);
  }
  showModalChoosingMentors.value = !showModalChoosingMentors.value
  holdMentor.value = {}
  console.log(mentorsSelected.value)
}

function closeChoosing() {
  holdMentor.value = {}
  showModalChoosingMentors.value = !showModalChoosingMentors.value
}

function holdMentorData(item){
  holdMentor.value = item
  showModalChoosingMentors.value = !showModalChoosingMentors.value
}

function  isInArray(itemId, array) {
  return array.some(obj => obj._id === itemId);
}

function sendMentors() {
  showModalSendMentors.value = true
  loadingRequest.value = true
  let objData = {
    "mentor_id_1": mentorsSelected.value[0]._id,
    "mentor_id_2": mentorsSelected.value[1]._id,
    "mentor_id_3": mentorsSelected.value[2]._id
  }
  requestApi({
    url: `v2/vivo_manager_mentor_mentoship/video/${process.env.VUE_APP_VIDEO_ID}/user/${window.ovmConfig.env['CPF']}/add_mentor_to_send_invitation`,
    method: 'POST',
    headers: {
      BCS: globalStateStore.uuid,
      'Content-Type': 'application/json',
    },
    data: objData
  }).then(() => {
    loadingRequest.value = false
  })
}

</script>

<template>
  <div id="trilha-de-cuidados">
    <div class="header">
        <div style="display: flex; flex-direction: column; align-items: start; width: 80%;">
            <v-btn @click="$emit('close-mentor')" variant="text" color="inherit">
              <img src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/642712b9-7c61-4e25-87b0-5b7aefc49d67.svg" alt="">
            </v-btn>
            <img style="position: absolute; left: 41%; top: 3%; width: 25%;" src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/7318d3ab-1168-4a6c-8944-4e4a4fae9059.svg" alt="">
            <p class="submenu-title">Seu Top 3</p>
            <p class="desc-title">{{ props.choosedMentor === false ? 'Escolha 3 mães acolhedoras em ordem de preferência' : 'Conheça melhor sua mãe acolhedora'}}</p>
        </div>
    </div>
    <div v-if="props.choosedMentor === false || props.choosedMentor === null" class="choosingMentor">
      <div class="mentor-container">
        <button
          v-for="(item, key) in mentors"
          :key="key"
          class="button"
          @click="holdMentorData(item)"
          :class="{ 'highlighted': isInArray(item._id, mentorsSelected) }"
        >
          <img class="img" :src="item.photo" alt="" />
          <p class="info-title">{{ item.name.split(' ').slice(0,2).join(' ') }}</p>
          <p class="info">{{ item.position }}</p>
          <div class="showPosition" v-if="isInArray(item._id, mentorsSelected)">{{ mentorsSelected.findIndex(obj => obj._id === item._id)+1 }}</div>
        </button>
      </div>
      <v-btn @click="sendMentors()" :disabled="mentorsSelected.length < 3" flat class="text-none" color="#660099" style="width:90%; position: absolute; bottom: 12%; left: 5%;">Confirmar</v-btn>
    </div>
    <div v-else>
      <img style="width: 150px;border-radius: 80px;height: 150px;margin-top: 10%;" :src="props.choosedMentor.photo" alt="">
      <p style="font-size: 20px;" class="info-title">{{ props.choosedMentor.name.split(' ').slice(0,2).join(' ') }}</p>
      <p style="font-size: 18px;" class="info">{{ props.choosedMentor.position }}</p>
      <p style="font-size: 18px;" class="info">{{ props.choosedMentor.phone }}</p>
    </div>
    <div v-if="showModalSendMentors || showModalChoosingMentors" class="modal-background">
    </div>
    <div v-if="showModalSendMentors" class="modal-container">
      <img style="margin-top: 15%; width: 60%;" src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/339ebd0c-ec87-4c3f-a10b-62d993620c36.svg" class="icon" alt="">
      <p style="font-weight: bold; margin-top: 6%;">Tudo Certo!</p>
      <p style="width: 70%; margin-left: 15%; margin-top: 5px; font-size: 11px; text-align: center;">Em breve entraremos em contato para marcar esse encontro.</p>
      <v-btn v-if="!loadingRequest" @click="$emit('close-mentor')" :disabled="mentorsSelected.length < 3" flat class="text-none" color="#660099" style="width:90%; position: absolute; bottom: 5%; left: 5%;">Confirmar</v-btn>
      <v-progress-circular
        v-else
        indeterminate
        color="#BC4AFF"
        :size="50"
        :width="7"
        style="margin-top: 5%;"
      ></v-progress-circular>
    </div>
    <div v-if="showModalChoosingMentors" class="modal-container-choose">
      <v-btn style="position: absolute; right: 0%; top: 2%;" @click="closeChoosing()" variant="text" color="inherit">
        <img src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/49cfce54-7e36-44c8-a65a-8c4a6069eee4.svg" alt="">
      </v-btn>
      <img style="width: 100px; border-radius: 80px; height: 100px; margin-top: 10%;" :src="holdMentor.photo" alt="">
      <p style="font-size: 20px;" class="info-title">{{ holdMentor.name.split(' ').slice(0,2).join(' ') }}</p>
      <p style="font-size: 18px;" class="info">{{ holdMentor.position }}</p>
      <div style="height: 30%; margin-top: 3%; overflow: auto;">
        <p style="font-size: 13px;" class="info">{{ holdMentor.biography }}</p>
      </div>
      <v-btn @click="addMentor(holdMentor)" flat class="text-none" color="#660099" style="width: 90%; position: absolute; bottom: 4%; left: 5%;">Selecionar</v-btn>
    </div>
  </div>
</template>

<style scoped>
  #trilha-de-cuidados {
    width: 100%;
    height: 100%;
    background: #F8F2FF;
    position: absolute;
    top: 0;
    z-index: 1;
  }

  .header {
    height: 25%;
    background-color: #BC4AFF;
    display: flex;
  }

  .submenu-title {
    color: white;
    margin-top: 7%;
    font-size: 20px;
    text-align: start;
    margin-left: 10%;
  }

  .desc-title {
    color: white;
    font-size: 12px;
    text-align: start;
    margin-left: 10%;
  }

  .mentor-container{
    position: absolute;
    top: 26%;
    width: 95%;
    height: 53%;
    overflow: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-left: 5%;
    align-content: baseline;
    padding-right: 5%;
    padding-top: 5%;
  }

  .icon-wrapper {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #F6E7FF;
    border-radius: 50%;
  }

  .button {
    position: relative;
    cursor: pointer;
    margin-bottom: 5%;
    width: 48%;
    min-height: 38%;
    background-color: white;
    border-radius: 15px
  }

  .img {
    width: 45px;
    height: 45px;
    border-radius: 70px;
  }

  .info-title{
    color: black;
    font-size: 0.8em;
    width: 100%;
    text-align: center;
    padding-left: 7%;
    padding-right: 7%;
    font-weight: bold;
  }

  .info {
    color: black;
    font-size: 0.6em;
    width: 100%;
    text-align: center;
    padding-left: 7%;
    padding-right: 7%;
  }

  .highlighted{
    border: solid 0.5px #660099;
  }

  .showPosition{
    position: absolute;
    top: 6%;
    right: 5%;
    width: 15%;
    border-radius: 20px;
    background-color: #660099;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    height: 20%;
  }

  .modal-background {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 4;
    background-color: black;
    opacity: 0.4;
  }

  .modal-background {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 4;
  background-color: black;
  opacity: 0.4;
}

.modal-container {
  position: absolute;
  width: 90%;
  height: 58%;
  border-radius: 12px;
  background-color: #fff;
  top: 15%;
  left: 5%;
  z-index: 4;
}

.modal-container-choose {
  position: absolute;
  width: 90%;
  height: 68%;
  border-radius: 12px;
  background-color: #fff;
  top: 10%;
  left: 5%;
  z-index: 4;
}

.close {
  position: absolute !important;
  left: 75%;
  top: 2%;
}

.close img {
  width: 20px;
}
</style>